import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import type { ComponentType, SVGProps } from 'react'
import { MenuItemContent } from './MenuItemContent'
import { getMenuItemClassName } from './menu-item-styles'

export type MenuItemVariant = 'primary' | 'neutral' | 'destructive'

export interface MenuItemProps {
  /** Item label */
  label: string
  /** Called when the item is selected */
  onSelect: () => void
  /** Visual variant: primary (brand blue), neutral (gray), destructive (red) */
  variant?: MenuItemVariant
  /** Optional icon shown before the label */
  icon?: ComponentType<SVGProps<SVGSVGElement>>
  /** Optional subheading shown below the label (e.g. for menu items with description) */
  subheading?: string
  /** Optional trailing icon (e.g. ChevronRight for submenus or navigation) */
  trailingIcon?: ComponentType<SVGProps<SVGSVGElement>>
  /** When true, the item is displayed as selected */
  selected?: boolean
  /** When true, the item is disabled (not selectable, True Gray/300 styling) */
  disabled?: boolean
}

export function MenuItem({
  disabled = false,
  icon: Icon,
  label,
  onSelect,
  selected = false,
  subheading,
  trailingIcon: TrailingIcon,
  variant = 'primary',
}: MenuItemProps) {
  return (
    <DropdownMenu.Item
      onSelect={onSelect}
      disabled={disabled}
      className={getMenuItemClassName({ disabled, selected, subheading, variant })}
      data-ds-component="MenuItem"
      data-ds-variant={variant}
      data-selected={selected ? '' : undefined}
    >
      <MenuItemContent
        disabled={disabled}
        icon={Icon}
        label={label}
        selected={selected}
        subheading={subheading}
        trailingIcon={TrailingIcon}
        variant={variant}
      />
    </DropdownMenu.Item>
  )
}
